import { Component, Output, EventEmitter, OnInit, ViewChild, ElementRef, Input, SimpleChanges, inject } from '@angular/core';
import { AppService } from '../services/services';
import { EmailValidator, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../validators/validation.service';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { EncryptionService } from '../services/encryption.service';
import { trigger, style, animate, transition } from '@angular/animations';
import { NgOtpInputComponent } from 'ng-otp-input';
import { Params } from '../nridiy/model';
import { ErrorModalComponent } from '../common/error-modal/error-modal.component';
import { AutocompleteComponent } from 'angular-ng-autocomplete';
import { OwlOptions,CarouselComponent } from 'ngx-owl-carousel-o';
import * as bootstrap from 'bootstrap';
@Component({
    selector: 'nri-app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false,
    animations: [
      trigger('enterAnimation', [
        transition(':enter', [style({
          opacity: 0,
          transform: 'translateY(-100%)'
        }),
        animate(400)
      ])
      ])
    ]
  })

export class RegisterComponent implements OnInit{
  @Output() registerStatus = new EventEmitter<boolean>();
  @ViewChild('owlCar') owlCar: CarouselComponent;
  resumeModal: any;
  codeKeyword = 'TeleCode'
  countryCode: any;
  countryList: any;
  panModal: any;
  encData: any;
  email: any = '';
  emailOTP: any = '';
  emailToggle: boolean = false;
  otpError: boolean = false;
  otpResumeError: boolean = false;
  otpSection: boolean = false;
  refExists: boolean = false;
  reSendOTP: boolean = false;
  reSendResumeOTP: boolean = false;
  rmAssist: boolean = false;
  rmEmail: any = null;
  rmEmailEmpty: boolean = false;
  rmDomain: string = '@sbicapsec.com';
  rmSameEmailError: boolean = false;
  showOTP: boolean = false;
  token: any;
  errorMessage: string = '';
  timer: boolean = false;
  public formBuilder = inject(FormBuilder);
  registerForm = this.formBuilder.group({
    // 'CustomerPan': ['', Validators.required, ValidationService.panValidator],
    // 'CustomerName': ['', [Validators.required,Validators.minLength(3), this.noWhitespaceValidator]],
    'Mobile': ['', [Validators.required, Validators.minLength(7),this.validateMobileNumber]],
    'CustomerEmail': [{value: '', disabled: this.otpSection}, Validators.required, ValidationService.emailValidator]
  });
  firstName: string = '';
  lastName: string = '';
  middleName: string = '';
  blockApp: boolean = true;
  resumePan: any;
  resumeOTPArea: boolean;
  resumeOTP: string = '';
  submitted: boolean = false;
  ri: boolean = false;
  existingDemat: boolean;
  nre_nonpis: boolean = true;
  nre_nonpisno: string = '';
  nre_pis: boolean = true;
  nre_pisno: string = '';
  nro_nonpis: boolean = true;
  nro_nonpisno: string = '';
  nro_pis: boolean = true;
  nro_pisno: string = '';
  panLoader: boolean = false;
  panVerified: boolean;
  rmfullemail: string = '';
  countryCodeError: boolean;
  resumePanError: boolean;
  rmchekbox:boolean = false;
  staticBackdrop:any;
  finalmodal:boolean = false;
  existingPan:any;
  remarks:string;
  errorModalbox: any;
  pansite:any;
  pansiteDecrypt: any;
  panErrorMessage: string = "PAN is required."
  panValidMessage: string = "Please enter a valid PAN for an Individual."
  otp:string;
  NRO :string = '';
  resumeUTM: boolean = false;
  @ViewChild('ngOtpInput', { static: false}) ngOtpInput: NgOtpInputComponent;
  @ViewChild('resumeInput') resumeInput : ElementRef;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px',
      'border-top':'none',
      'border-left':'none',
      'border-right':'none',
      'outline':'none',
      'border-radius':'0'
    }
  };
  terms:boolean = false;
  mob: any;
  utmSource: string = "";
  utmCampaign: string = "";
  utmMedium : string = "";
  codeDisable: boolean = false;
  googleModal: Modal;
  NROPop :Modal;
  redirectionEmail:string;
  googleCode:any;
  googleEmail:any;
  rmResEmail:string = "";
  keyword:string = "";
  rmLists:any = [];
  @ViewChild('errorComp') errorComp : ErrorModalComponent;
  regScreen: boolean = false;
  tcPopUp: Modal;
  fatf:boolean;
  fatfCountry: Array<any> = [];
  fatfKeyword: string = 'Country';
  selectedFatf: string = "";
  isMobile: boolean = false;
  @ViewChild('autocomplete') autocomplete: AutocompleteComponent;
  inline:boolean = false;
  newCoun:string = "";
  EmailField: boolean = false;
  EsignStatus : string = '';
  mobilemodal :boolean =false;
  emailmodal :boolean =false;
  customOptions: OwlOptions = {
    loop: false,
    margin: 10,
    autoplay: false,
    dots: true,
    navSpeed: 700,
    // navText: ['<img src="./assets/images/arrow-left.png" height="24">', '<img src="./assets/images/arrow-right.png" height="24">'],
    responsive: {
      0: {
        items: 1
      },
      480: {
        items: 4
      },
      940: {
        items: 6
      }
    },
    nav: true
  }
  whyChoose: Array<any> = [
    { imageUrl:'./assets/images/Layer_1.png',
      title: 'Trusted Brand',
      description: "Backed by the strength of SBI, India's most trusted and largest public sector bank."
    },
    { imageUrl:'./assets/images/layer_2.png',
      title: 'Global Access',
      description: "Trade from anywhere in the world with our secure and user-friendly online trading platform."
    },
    { imageUrl:'./assets/images/Support.png',
      title: 'Dedicated Support',
      description: "Get expert assistance and guidance tailored specifically for NRIs."
    },
    { imageUrl:'./assets/images/Charges.png',
      title: 'Competitive Charges',
      description: "Transparent and competitive brokerage charges, ensuring value for your investments."
    },
    { imageUrl:'./assets/images/Multi Account.png',
      title: 'Multi-Account Integration',
      description: "Easily link your NRE/NRO bank accounts for smooth repatriation and fund management."
    }]
  keyFeatures: Array<any> = [
    { imageUrl:'./assets/images/key1.png',
      title: 'Simple and Fast Account Opening',
      description: "Hassle-free online process with minimal documentation."
    },
    { imageUrl:'./assets/images/key2.png',
      title: 'Multiple Investment Options',
      description: "Access a wide range of investment opportunities, including equities, IPOs, mutual funds, ETFs, and bonds."
    },
    { imageUrl:'./assets/images/key3.png',
      title: 'Portfolio Investment Scheme (PIS) Compliant',
      description: "Invest in Indian markets in full compliance with RBI's Portfolio Investment Scheme (PIS) regulations."
    },
    { imageUrl:'./assets/images/key4.png',
      title: 'Repatriation Benefits',
      description: "Conveniently transfer your profits and investments abroad with the NRE account (repatriation basis)."
    },
    { imageUrl:'./assets/images/key5.png',
      title: 'Real-Time Market Access',
      description: "Stay updated with real-time stock quotes, charts, and research insights to make informed decisions."
    }]
    backgroundImages:any = {
      'tab1': './assets/images/full1.png',
      'tab2': './assets/images/full2.png',
      'tab3': './assets/images/full3.png',
      'tab4': './assets/images/full4.png',
  };
  currentBackground: string = this.backgroundImages.tab1;
  resumeJourney: boolean = false;
  decref: string = "";
  maxHeight: number;
  search : any = {};
  rmApp : boolean = false;
  IsmartId: string = "";
  ApplicationType: string = "";
  constructor(public toastr: ToastrService,private loader: NgxUiLoaderService, private router: Router, public _http: AppService, public encrypt:EncryptionService){
    if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(){
      this.registerStatus.emit(false);
      this.getCountryList();
      this.getMasters();
      let refNo = sessionStorage.getItem("AxNo");
      if(refNo){
        this.getDIYStatus(refNo)
      }
      let href = location.href;
      this.googleCode = this.getParameterByName("code",href);
      this.googleEmail = this.getParameterByName("email",href);
      if(this.googleCode && this.googleEmail) {
          this.getRedirectionGoogle(this.googleCode,this.googleEmail)
      }
      const resumeStatus = this.getParameterByName("resume",href);
      if(resumeStatus){
        this.resumeApp();
        sessionStorage.setItem("resumeJourney",resumeStatus);
      }
      const resume = sessionStorage.getItem("resumeJourney");
      if(resume && location.pathname === "/register"){
        this.resumeApp();
      }

      this.search = JSON.parse(sessionStorage.getItem('searchParams') || '{}')
       this.registerForm.patchValue({
      Mobile: this.search.mobile || '',
      CustomerEmail: this.search.email || ''
    });

    // ✅ ngModel fields
    if (this.search.countrycode) {
      this.newCoun = this.search.countrycode;
      this.countryCode = this.search.countrycode;
    }
     if (this.search.ismartid ) {
      this.IsmartId = this.search.ismartid;
      sessionStorage.setItem('IsmartURL',location.href)
     }
     if(this.search.applicationtype){
      this.ApplicationType = this.search.applicationtype
     }
      if (this.search?.lgcode) {
        this.rmAssist = true;
        this.rmApp = true;
        this.rmEmail = this.search?.lgcode;
      }
      if (Object.keys(this.search).length > 0) {
      this.EsignStatus = this.search['esign'];
    }
  }

  ngAfterViewInit(){
    let utm_source = sessionStorage.getItem("utmSource");
    let utm_medium = sessionStorage.getItem("utmMedium");
    let utm_campaign = sessionStorage.getItem("utmCampaign");

    if(utm_source){
      this.utmSource = utm_source;
    }
    if(utm_medium){
      this.utmMedium = utm_medium;
    }
    if(utm_campaign){
      this.utmCampaign = utm_campaign;
    }
    setTimeout(() => {
      this._http.scroll();
    }, 0);
    //If Dynamic height Needed
    // let arr = ["card_height" , "card_height1"];
    // arr.forEach(e => {
    // let heightOfEle:any = document.getElementsByClassName(e);
    // if (heightOfEle.length > 0) {
    //   let heightOfEleme =  Array.from(heightOfEle).map((data:any) => data.clientHeight)
    //   this.maxHeight = Math.max(...heightOfEleme);
    //   let bindstyle = Array.from(heightOfEle).forEach((data:any) => {
    //     data.style.height = `${this.maxHeight + 25}px`;
    //   })
    //   return bindstyle;
    // }
    // })
  }

  tabChange(tab:string){
    this.currentBackground = this.backgroundImages[tab];
  }

  onChangeSearch(searchString:any){
    if(searchString){
      this._http.getRmList(searchString).subscribe({
        next: (data:any) => {
          var filtered:any = [];
          if(data && data.RMIDs){
            data.RMIDs.forEach((element:any) => {
              filtered.push(element.RMID);
              if(filtered.length > 0){
                this.rmLists = [...new Set(filtered)];
              }
          });
          }
        }
      })
    }
  }
  selectEvent(event:any){
    if(event){
      this.rmEmail = event;
    }
  }
  deleteRm(event:any){
    if(event){
      this.rmEmail = "";
    }
  }
  deleteFatf(event:string){
    if(event){
      this.selectedFatf = "";
    }
  }
  selectfatf(event:any){
    if(event){
      this.selectedFatf = event.Country;
    }
  }
  fatfCheck(value:any){
    if(value){
      const fatfval = this.fatfCountry.filter((item:any) => item.Country === value.Country);
      if(fatfval.length > 0){
        this.selectfatf(fatfval[0]);
      }
    }
  }
  rmidCheck(id:string){
    if(id){
      const RMID = this.rmLists.filter((item:any) => item === id);
      if(RMID.length > 0){
        this.selectEvent(RMID[0]);
      }
    }
  }

  getParameterByName(name:string, url:string) {
    //if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&|]" + name + "(=([^&#|]*)|&|#|$)", 'i'),
    results = regex.exec(url);
    if (!results)
      return null;
    if (!results[2])
      return '';
    return results[2].replace(/\+/g, " ");
  }

  getMasters(){
    let url = 'DIY/GetMasters';
    this._http.httpGet(url).subscribe({
      next: (data:any)=>{
        this._http.setMasters(data)
        this.fatfCountry = data.FATFCountry;        
      },error: _error =>{
  
      }
    });
   }

  getCountryList(){
    this.loader.start();
    this._http.getCountryList().subscribe({
      next: (data:any)=>{
        this.loader.stop();
        this.countryList = data;
        this._http.countryList = data;
        if(sessionStorage.getItem('AxNo')){
          let ref:any = sessionStorage.getItem('AxNo')
          this._http.setRefNum(ref);
          // this.getDIYStatus(ref);
        }
      }, error: e =>{
        this.loader.stop();
        this.errorComp.ModalShow(e.error.Message);

      }
    });
  }

  // checkCode(){
  //   let c = '';
  //   if(this.countryCode.TeleCode){
  //     c =  this.countryCode.TeleCode;
  //   }else{
  //     c = this.countryCode;
  //   }

  //   let code = this.countryList.filter((e:any)=>{
  //     return e.TeleCode === c
  //   })
  //   if(!code || code.length === 0){
  //     this.countryCodeError = true;
  //   }else{ 
  //     this.countryCodeError = false;
  //   }
  // }

  checkCode() {
    let c = '';
    if (this.countryCode && this.countryCode.TeleCode) {
      c = this.countryCode.TeleCode;
    } else {
      c = this.countryCode;
    }
  
    let code = this.countryList.filter((e: any) => {
      return e.TeleCode === c;
    });
  
    if (!code || code.length === 0) {
      this.countryCodeError = true;
    } else {
      this.countryCodeError = false;
    }
    if(this.countryCodeError){
      this.countryCode = "";
      this.newCoun = "";
    }
    this.inline = false;
  }

  focus(){
   this.inline =! this.inline;
   setTimeout(() => {
    if(this.inline){
      this.autocomplete.focus();
    }
   }, 0);
  //  if(this.inline){
  //   this.autocomplete.focus();
  //   this.autocomplete.open();
  //  }
  }

  resumeApp(){
    this.resumeJourney = true;
    this.resumeOTPArea = false;
    this.resumeOTP = '';
    // const element = document.getElementById('resumeModals') as HTMLElement;
    // this.resumeModal = new Modal(element, {backdrop: 'static', keyboard: false});
    // this.resumeModal.show();
  }

  closeModal(){
    // this.resumeModal.hide();
    this.panModal.hide();
  }

 
  panResumeVal(){
    let panfilter = /[a-z]{3}[p][a-z]{1}\d{4}[a-z]/i;
    if(this.resumePan && this.resumePan.length === 10 && panfilter.test(this.resumePan)){
      let params ={
        "PanNumber": this.resumePan.toUpperCase()
      }
      let checkSum = this.resumePan.toUpperCase();
      let url = "DIY/Resume";
      this.reSendResumeOTP = false;
      this.loader.start();
      this._http.httpPost(url, params, checkSum).subscribe({
        next: (data:any)=>{
          this.loader.stop();
            let decryptedValue = this.encrypt.decryptUsingAES256(data.OutPut);
            if(decryptedValue && decryptedValue.IsSuccess){
              this.resumeOTPArea = true;
              this.timer = true;
              this.reSendOTP = false;
              this.encData = decryptedValue;
              // this.toastr.success("OTP will sent to your registered Email id");
              this.resumePanError = false;
            }
          else{
            if(decryptedValue.Error){
              this.errorComp.ModalShow(decryptedValue.Error)
            }else{
              this.errorComp.ModalShow("We are unable to find details matching to the information provided to us. For more details you can connect us on 022-40508080")
            }
          }
        },
        error: error=>{
          this.loader.stop();
          if(!window.navigator.onLine){
            this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.")
          }else{
            this.errorComp.ModalShow(error.error.Message)
          }
        }
      })
    }else{
      this.resumePanError = true;
      this.resumeInput.nativeElement.focus();
    }

  }
  
  resumeOTPVal(){
    if(!this.resumeOTP){
      // this.errorComp.ModalShow("Please Enter OTP");
      this.toastr.error("Please Enter OTP");
      return;
    }
    let params = {
      'Code': this.encData.Code,
      'Email': this.encData.Email,
      'OTP': this.resumeOTP
    }
    let checkSum = this.encData.Email + this.resumeOTP + this.encData.Code;
    let url = "DIY/VerifyResumeOTP";
    this.loader.start();
    this.otpResumeError = false;
    this._http.httpPost(url, params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let decryptedValue1 = this.encrypt.decryptUsingAES256(data.OutPut)
        if(decryptedValue1.IsSuccess){
          // this.resumeModal.hide();
          if(decryptedValue1.ReferenceNumber){
            sessionStorage.setItem('AxNo',decryptedValue1.ReferenceNumber);
            this._http.setRefNum(decryptedValue1.ReferenceNumber);
            if(this.utmCampaign || this.utmMedium || this.utmSource){
              this.resumeUTM = true;
              this.registerUTM(decryptedValue1.ReferenceNumber);
            }
            this.getDIYStatus(decryptedValue1.ReferenceNumber);
          }
        }
        else{
          this.otpResumeError = true;
          this.errorComp.ModalShow(decryptedValue1['Error']);
        }
      }, error: _error =>{
        this.loader.stop();
        if(!window.navigator.onLine){
          this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.")
        }else{
          this.errorComp.ModalShow(_error.error.Message)
        }
      }
    })
  } 

  termsConditions(event:boolean){
    this.terms = event;
  }

  assistClick(event:boolean){
    this.rmAssist = event;
    if(!this.rmAssist && this.rmEmail){
      this.rmEmail = "";
    }
    this.otpSection = false;
    this.registerForm.controls['CustomerEmail'].enable();
    // if(this.panVerified == true){
    //   this.registerForm.controls['CustomerPan'].disable();
    // }
    
  }

  public noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length? null : { 'whitespace': true };       
  }

  setRmDomain(domain: string){
    this.rmDomain = domain;
    this.emailToggle = false;
  }
  refreshPage(){
    this.resumePan = "";
    this.resumePanError = false;
    // this.registerForm.controls['CustomerPan'].enable();
    //   this.registerForm.controls.CustomerPan.setValue('');
    //   this.registerForm.controls.CustomerPan.markAsUntouched();
      this.panLoader = false;
      this.panVerified = false;
      this.timer = false;
    // this.resumeModal.hide();
  }


  // onPanChange(event: any) {
  //   const pattern = new RegExp('^[a-zA-Z0-9\b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //       event.preventDefault();
  //       return;
  //   }
  // }

  onPanChange(event: any) {
    const inputText = event.target.value;
    const sanitizedText = inputText.replace(/[^a-zA-Z0-9]/g, '');
  
    if (inputText !== sanitizedText) {
      event.target.value = sanitizedText;
    }
  }
  

  // alphaNumeric(event:any){
  //   const pattern = new RegExp('^[a-zA-Z0-9\b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //       event.preventDefault();
  //       return;
  //   }
  // }

  alphaNumeric(event: any) {
    const pattern = /^[a-zA-Z0-9\b]+/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      // Remove non-alphanumeric characters from the input value
      event.target.value = inputText.replace(new RegExp(`[^a-zA-Z0-9]+`, 'g'), '');
    }
  }
  

  // panValidation(){
  //   if(this.registerForm.controls.CustomerPan.value?.length === 10){
  //   this.blockApp = true;
  //   this.ri = false;
  //   this.refExists = false;
  //   const checkSum = this.registerForm.value.CustomerPan?.toUpperCase()+'N';
  //   const params = {
  //     "PanNumber": this.registerForm.value.CustomerPan?.toUpperCase(),
  //     "Mode":"N"
  //   }
  //   const path = 'DIY/PanSiteValidation';
  //   this.panLoader = true;
  //   this.registerForm.controls['CustomerPan'].disable();
  //   this.panVerified = false;
  //   this._http.httpPost(path, params, checkSum).subscribe({
  //       next: (data:any)=>{
  //         // this.pansite = data;
  //         this.pansite = this.encrypt.decryptUsingAES256(data.OutPut)
  //         this.panLoader = false;
  //         if(this.pansite && this.pansite.IsSuccess){
  //           this.panVerified = true;
  //           this.registerForm.controls['CustomerPan'].disable();
  //           this.toastr.success(this.pansite.Success);
  //           this.firstName = this.pansite.cClientInfo.FirstName;
  //           this.middleName = this.pansite.cClientInfo.MiddleName;
  //           this.lastName = this.pansite.cClientInfo.LastName;
  //           if(this.pansite.IsReferenceNumberExist){
  //             // this.toastr.info("PAN Already Exists");
  //             const element = document.getElementById('panModal') as HTMLElement;
  //             this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
  //             this.panModal.show();
  //             this.refExists = true;
  //             this.resumePan = this.registerForm.value.CustomerPan;
  //           }
  //           else if(this.pansite.ExistingAcResponse && this.pansite.ExistingAcResponse.ExistingDemat){
  //             if(this.pansite.ExistingAcResponse.RI){
  //               const element = document.getElementById('panModal') as HTMLElement;
  //               this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
  //               this.panModal.show();
  //               this.ri = true;
  //             }else {
  //               const element = document.getElementById('panModal') as HTMLElement;
  //               this.panModal = new Modal(element, {backdrop: 'static', keyboard: false});
  //               this.panModal.show();
  //               this.existingDemat = true;
  //               this.pansite.ExistingAcResponse.BankResponses.forEach((e:any)=>{
  //                 if(e.CLIENT_SETTLEMENT_TYPE === "NRE-NONPIS"){
  //                   this.nre_nonpis = false;
  //                   this.nre_nonpisno = e.DEMAT_ACC_NO;
  //                 }
  //                 if(e.CLIENT_SETTLEMENT_TYPE === "NRE-PIS"){
  //                   this.nre_pis = false;
  //                   this.nre_pisno = e.DEMAT_ACC_NO;
  //                 }
  //                 if(e.CLIENT_SETTLEMENT_TYPE === "NRO-NONPIS"){
  //                   this.nro_nonpis = false;
  //                   this.nro_nonpisno = e.DEMAT_ACC_NO;
  //                 }
  //                 if(e.CLIENT_SETTLEMENT_TYPE === "NRO-PIS"){
  //                   this.nro_pis = false;
  //                   this.nro_pisno = e.DEMAT_ACC_NO;
  //                 }
  //               })
  //             }
  //           }
  //           else{
  //             this.blockApp = false;
  //           }
  //         }else{
  //           this.blockApp = true;
  //           this.errorComp.ModalShow(this.pansite.Error)
  //           this.registerForm.controls['CustomerPan'].enable();
  //         }
  //       },error: e =>{
  //         this.panLoader = false;
  //         this.registerForm.controls['CustomerPan'].enable();
  //         this.errorComp.ModalShow(e.error.Message);
  //       }
  //   });
  // }
  // }

  panResumeYes(){
    // this.panResumeVal();
    // this.panModal.hide();
    // this.resumePan = this.registerForm.controls.CustomerPan.value;
    // if(this.registerForm.controls.CustomerPan.value){
    //   this.registerForm.controls.CustomerPan.setValue('');
    //   this.registerForm.controls.CustomerPan.markAsUntouched();;
    //   this.panLoader = false;
    //   this.panVerified = false;
    // }
    
    this.resumeApp();
  }

  riResumeYes(){
    this.panModal.hide();
    this.blockApp = false;
  }

  panResumeNo(){
      if(this.resumePan){
        this.resumePan = "";
      }
    // this.panModal.hide();
    // if(this.registerForm.controls.CustomerPan.value){
      // this.registerForm.controls['CustomerPan'].enable();
      // this.registerForm.controls.CustomerPan.setValue('');
      // this.registerForm.controls.CustomerPan.markAsUntouched();;
      this.panLoader = false;
      this.panVerified = false;
    // }
  }

  completed(){
    window.location.reload();
  }

  // onInputChange(event: any) {
  //   const pattern = new RegExp('^[a-zA-Z \b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //     event.preventDefault();
  //     return;
  //   }
  // }
  onInputChange(event: any) {
    const pattern = /^[a-zA-Z \b]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      // Remove invalid characters from the input value
      event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
    }
  }

  spaceValidation(event:any){
    const input = event.target.value;
    event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    // this.registerForm.controls.CustomerName.setValue(event.target.value);
  }

  onlyNumberKey(event: any) {
    const pattern = new RegExp('^[0-9\b]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!pattern.test(key) && event.charCode !== 0) {
      event.preventDefault();
      return;
    }
  }

   validateMobileNumber(control: any ) {
    const mobileNumber = control.value;
    const dummyMobileRegex = /^(0+|1+|2+|3+|4+|5+|6+|7+|8+|9+)$/;

    if (dummyMobileRegex.test(mobileNumber)) {
      return { dummyMobileNumber: true };
    }

    return null;
  }

  togglePasswordVisibility() {
    this.showOTP = !this.showOTP;
    const otpInput = document.getElementById('rmotp') as HTMLInputElement;
    otpInput.type = this.showOTP ? 'text' : 'password';
  }

  mobileCheckAPi(){
    this.loader.start();
    const url = `DIY/DIYUpdateLoginInfo`;
    const params = {
      "Mobile_Number": this.registerForm.controls.Mobile.value,
      "email": this.registerForm.controls.CustomerEmail.value,
      "Url": location.href
      }
    this._http.httpPost(url,params,"").subscribe({
      next: (data:any) => {
        this.loader.stop();
        if(data){
          // console.log(this.encrypt.decryptUsingAES256(data.OutPut));
        }
      }, error : e => {
        this.loader.stop();
        this.errorComp.ModalShow(e.error.Message);
      }
    })
    

  }
  filter(items: any[], query: string): any[] {
    const lowerCaseQuery = query.toLowerCase();
    return items.filter(item =>
      item.TeleCode.toLowerCase().startsWith(lowerCaseQuery) ||
      item.Name.toLowerCase().startsWith(lowerCaseQuery)
    );
  }
  


  genOTP(){
    if(!this.registerForm.controls.CustomerEmail.value){
      this.errorComp.ModalShow("Please Provide Email");
      return;
    }
    // if(!this.registerForm.controls.Mobile.value){
    //   this.errorComp.ModalShow("Please Provide Mobile Number");
    //   return;
    // }
    if(!this.countryCode){
      this.errorComp.ModalShow("Please Provide Country Code");
      return;
    }
    // this.mobileCheckAPi();
    this.ngOtpInput.setValue("");
    this.submitted = true;
    // if(this.registerForm.valid){
      let error = 0;
      this.email = this.registerForm.controls.CustomerEmail.value;
      if(this.rmAssist){
        this.rmchekbox = true;
        this.rmfullemail = this.rmEmail + this.rmDomain;
        if(this.rmfullemail === this.registerForm.controls.CustomerEmail.value){
          this.rmSameEmailError = true;
          error++;
        }
      }
      if(this.rmAssist && !this.rmEmail){
        this.errorComp.ModalShow("Please Provide Employee ID");
        this.rmchekbox = false;
        return;
      }
      if(this.rmAssist){
        if(!this.rmfullemail){
          this.errorComp.ModalShow("Please Provide RMEmail");
          return;
        }
      }
      if(error === 0){
        let checkSum = '';
        if(this.rmAssist){
          checkSum = this.registerForm.controls.CustomerEmail.value + this.rmfullemail;
        }else{
          checkSum = this.registerForm.controls.CustomerEmail.value + this.email;
        }
        this.mob = this.registerForm.controls.Mobile.value;
        const params:RMParams = {
          "CustomerEmail": this.registerForm.controls.CustomerEmail.value,
          "IsRMJourney":this.rmAssist,
          "RMEmail": "",
          "Email":  this.email,
          "Mobile": this.registerForm.controls.Mobile.value?.trim(),
          'NRO': this.NRO
        }
        if(this.rmAssist){
          params['RMID'] = this.rmEmail;
        }
        this.loader.start();
        this.reSendOTP = false;
        const path = 'DIY/EmailOtp';
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
            let emailDecrypt = this.encrypt.decryptUsingAES256(data.OutPut)
            this.loader.stop();
            if(emailDecrypt && emailDecrypt.IsSuccess){
              if(emailDecrypt.RMEmail){
                this.rmResEmail = emailDecrypt.RMEmail;
                sessionStorage.setItem("RMEmail", this.rmResEmail)
              }
              // this.otpSection = true;
              this.generateOTP();
              this.registerForm.controls['CustomerEmail'].disable();
              this.registerForm.controls['Mobile'].disable();
              this.codeDisable = true;
            }else{
              if(emailDecrypt && emailDecrypt.Error){
              this.errorComp.ModalShow(emailDecrypt.Error);
              if(this.rmAssist){
                this.rmchekbox = false;
              }
              }else{
                this.errorComp.ModalShow("Please try again later.");
              }
            }
          }, error: e =>{
            this.loader.stop();
            if(!window.navigator.onLine){
                 this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
            }else{
              this.errorComp.ModalShow(e.error.Message);
            }
          }
        });
      }
    // }
  }
MobgenOTP(){
    // if(!this.registerForm.controls.CustomerEmail.value){
    //   this.errorComp.ModalShow("Please Provide Email");
    //   return;
    // }
    // if(!this.registerForm.controls.Mobile.value){
    //   this.errorComp.ModalShow("Please Provide Mobile Number");
    //   return;
    // }
    if(!this.countryCode){
      this.errorComp.ModalShow("Please Provide Country Code");
      return;
    }
    if(!this.registerForm.controls.Mobile.value){
      this.errorComp.ModalShow("Please Provide Mobile Number");
      return;
    }
    // this.mobileCheckAPi();
    this.ngOtpInput.setValue("");
    this.submitted = true;
    // if(this.registerForm.valid){
      let error = 0;
      this.email = this.registerForm.controls.CustomerEmail.value;
      if(this.rmAssist){
        this.rmchekbox = true;
        this.rmfullemail = this.rmEmail + this.rmDomain;
        if(this.rmfullemail === this.registerForm.controls.CustomerEmail.value){
          this.rmSameEmailError = true;
          error++;
        }
      }
      if(this.rmAssist && !this.rmEmail){
        this.errorComp.ModalShow("Please Provide Employee ID");
        this.rmchekbox = false;
        return;
      }
      if(this.rmAssist){
        if(!this.rmfullemail){
          this.errorComp.ModalShow("Please Provide RMEmail");
          return;
        }
      }
      if(error === 0){
        let checkSum = '';
        if(this.rmAssist){
          checkSum = this.registerForm.controls.CustomerEmail.value + this.rmfullemail;
        }else{
          checkSum = this.registerForm.controls.CustomerEmail.value + this.email;
        }
        this.mob = this.registerForm.controls.Mobile.value;
        let params: { [key: string]: any } = {};
        let ccode = '';
        if(this.countryCode.TeleCode){
          ccode =  this.countryCode.TeleCode;
        }else{
          ccode = this.countryCode;
        } 
        params['EmailFlag'] = false;
        params['Mobile'] = this.registerForm.controls.Mobile.value?.trim() || '';
        params['MobileFlag'] = true;
        params['CountryCode'] = ccode;
         if(this.rmAssist){
          params['RMID'] = this.rmEmail;
        }
        this.loader.start();
        this.reSendOTP = false;
        let path =''
           path = 'DIY/MobileOTPGeneration'
        
        this._http.httpPost(path, params, checkSum).subscribe({
          next: (data:any)=>{
            let emailDecrypt = this.encrypt.decryptUsingAES256(data.OutPut)
            this.loader.stop();
            if(emailDecrypt && emailDecrypt.IsSuccess){
              // if(emailDecrypt.RMEmail){
              //   this.rmResEmail = emailDecrypt.RMEmail;
              //   sessionStorage.setItem("RMEmail", this.rmResEmail)
              // }
              // this.otpSection = true;
               this.codeDisable = true;
              this.mobgenerateOTP();
              // this.registerForm.controls['CustomerEmail'].disable();
              this.registerForm.controls['Mobile'].disable();
             
            }else{
              if(emailDecrypt && emailDecrypt.Error){
              this.errorComp.ModalShow(emailDecrypt.Error);
              if(this.rmAssist){
                this.rmchekbox = false;
              }
              }else{
                this.errorComp.ModalShow("Please try again later.");
              }
            }
          }, error: e =>{
            this.loader.stop();
            if(!window.navigator.onLine){
                 this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
            }else{
              this.errorComp.ModalShow(e.error.Message);
            }
          }
        });
      }
    // }
  }
  validateOTP(){
    // if(this.emailOTP && this.emailOTP === "2319"){
    //   this.signUP();
    // }else{
    //   this.errorComp.ModalShow("Invalid OTP");
    //   return;
    // }
    if(!this.emailOTP){
      this.toastr.error("Please Enter OTP");
      // this.errorComp.ModalShow("Please Enter OTP");
      return;
    }
    let checkSum = '';
    if(this.rmAssist){
      this.rmchekbox = true;
    }
      // checkSum = this.rmResEmail + this.emailOTP;
    // }else{
      checkSum = this.email + this.emailOTP;
    // }
    const params = {
      "Email": this.email,
      "OTP": this.emailOTP
    }
    this.loader.start();
    const path = 'DIY/ValidateOTP';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
        let value5 = this.encrypt.decryptUsingAES256(data.OutPut);
        this.loader.stop();
        this.token = value5.ErrorCode
        if(value5.IsSuccess){
          this.loader.stop();
          this.errorModalbox.hide();
          // if(this.registerForm.controls.CustomerEmail.value && this.gmailRegexCheck(this.registerForm.controls.CustomerEmail.value)) {
          //   this.redirectionEmail = this.registerForm.controls.CustomerEmail.value;
          //   const element = document.getElementById('googleModal') as HTMLElement;
          //   this.googleModal = new Modal(element, { backdrop: 'static', keyboard: false });
          //   this.googleModal.show();
          // }
          // else {
            this.IsEmailVerified(false);
          // }
          this.timer = false;
        }else{
          this.otpError = true;
          this.toastr.error(value5['Error']);
          // this.errorComp.ModalShow(value5['Error']);
        }
      }, error: _error =>{
        this.loader.stop();
        this.emailOTP = "";
        if(!window.navigator.onLine){
          this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
        }else{
          this.errorComp.ModalShow(_error.error.Message);
        }
      }
    });
  
  }
 validateMobileOTP(){
    // if(this.emailOTP && this.emailOTP === "2319"){
    //   this.signUP();
    // }else{
    //   this.errorComp.ModalShow("Invalid OTP");
    //   return;
    // }
    if(!this.emailOTP){
      this.toastr.error("Please Enter OTP");
      // this.errorComp.ModalShow("Please Enter OTP");
      return;
    }
    let checkSum = '';
    if(this.rmAssist){
      this.rmchekbox = true;
    }
      // checkSum = this.rmResEmail + this.emailOTP;
    // }else{
      checkSum = this.email + this.emailOTP;
    // }
    let ccode = '';
        if(this.countryCode.TeleCode){
          ccode =  this.countryCode.TeleCode;
        }else{
          ccode = this.countryCode;
        } 
    const params = {
       "Mobile": this.registerForm.controls.Mobile.value?.trim(),
        "OTP": this.emailOTP,
        'CountryCode':ccode
    }
    this.loader.start();
    const path = 'DIY/ValidateMobileOTP';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
        let value5 = this.encrypt.decryptUsingAES256(data.OutPut);
        this.loader.stop();
        this.token = value5.ErrorCode
        if(value5.IsSuccess){
          this.loader.stop();
            const otpModalEl = document.getElementById('otpModal');
        if (otpModalEl) {
          const otpModal = bootstrap.Modal.getInstance(otpModalEl) || new bootstrap.Modal(otpModalEl);
          otpModal.hide();
        }
          //  this.registerForm.controls['CustomerEmail'].disable();
              this.registerForm.controls['Mobile'].disable();
              this.codeDisable = true;
          // if(this.registerForm.controls.CustomerEmail.value && this.gmailRegexCheck(this.registerForm.controls.CustomerEmail.value)) {
          //   this.redirectionEmail = this.registerForm.controls.CustomerEmail.value;
            // const element = document.getElementById('NROPop') as HTMLElement;
            // this.NROPop = new Modal(element, { backdrop: 'static', keyboard: false });
            // this.NROPop.show();


            // const element = document.getElementById('googleModal') as HTMLElement;
            // this.googleModal = new Modal(element, { backdrop: 'static', keyboard: false });
            // this.googleModal.show();

            this.EmailField = true;
            this.genOTP();
          // }
          // else {
          //   this.IsEmailVerified(false);
          // }
          this.timer = false;
        }else{
          this.otpError = true;
          this.toastr.error(value5['Error']);
          // this.errorComp.ModalShow(value5['Error']);
        }
      }, error: _error =>{
        this.loader.stop();
        this.emailOTP = "";
        if(!window.navigator.onLine){
          this.errorComp.ModalShow("It appears that your internet connectivity is slow or please try again.");
        }else{
          this.errorComp.ModalShow(_error.error.Message);
        }
      }
    });
  
  }
  gmailRegexCheck(email:string) {
    var regEx = /([a-zA-Z0-9]+)([\.{1}])?([a-zA-Z0-9]+)\@gmail([\.])com/g;
    return regEx.test(email.toLowerCase());
  }

  public redirGoogle() {
    const url = `DIY/GetRequest`;
    this._http.httpGet(url).subscribe({
      next: (data:any) => {
        if(data){
          location.assign(data);
        }
      }
    })
    // this.toastr.info("Google Integration Is Under Construction!!");
  }

  getRedirectionGoogle(code:string,mail:string) {
    const url = `GetRequestToken?Mail=${mail}&Code=${code}`;
    this._http.httpGet(url).subscribe({
      next: data => {
        if(data){
          this.registerStatus.emit(true);
          this.router.navigate(['/pan'], {replaceUrl: true});
        }
      }
    })
  }

  IsEmailVerified(action:boolean){
    let checkSum = '';
    if(this.rmAssist){
      this.rmchekbox = true;
      // checkSum = this.rmResEmail + this.emailOTP + this.token;
    }
    // else{
      checkSum = this.email + this.emailOTP + this.token;
    // }
    const params = {
      "Email": this.email,
      "OTP": this.emailOTP,
      "Token":this.token
    }
    this.loader.start();
    const path = 'DIY/IsEmailVerified';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data:any)=>{
        let value4 = this.encrypt.decryptUsingAES256(data.OutPut)
        this.loader.stop();
        if(value4.IsSuccess){
          this.signUP(action);
        }
        else{
          this.loader.stop();
          this.errorMessage = value4.Error
          this.errorModal();
          // this.errorComp.ModalShow(data.Error)
          // this.registerForm.reset();
        }
      }, error: _error =>{
        this.loader.stop();
        // this.registerForm.reset();
        // this.otpError = true;
        this.errorComp.ModalShow(_error.error.Message)
      }
    })
  }

  signUP(redirect:boolean){
    //this.email = this.registerForm.value.CustomerEmail;
      this.mob = this.registerForm.controls.Mobile.value;
      this.email = this.registerForm.controls.CustomerEmail.value
      let rmemail = this.rmEmail;
      if(this.rmAssist){
        //this.email = this.rmEmail + this.rmDomain;
        rmemail = this.rmResEmail;
      }
      let mobile:any = this.registerForm.value.Mobile;

      const checkSum = this.email + mobile;
      let ccode = '';
      if(this.countryCode.TeleCode){
        ccode =  this.countryCode.TeleCode;
      }else{
        ccode = this.countryCode;
      }
      if(this.rmAssist){
      sessionStorage.setItem("RmList",JSON.stringify(this.rmAssist));
      // sessionStorage.setItem("RMEmail",rmemail);
      }
      const params = {
        "CustomerEmail": this.email,
        "IsRMJourney":this.rmAssist,
        "RMEmail": rmemail,
        "Mobile": this.registerForm.value.Mobile,
        "CustomerName": "",
        "CountryCode": ccode
      }
      this.loader.start();
      const path = 'DIY/SignUp';
      this._http.httpPost(path, params, checkSum).subscribe({
        next: (data: any)=>{
          let value3 = this.encrypt.decryptUsingAES256(data.OutPut)
          this.loader.stop();
          if(value3.IsSuccess){
            // this.genRefNumber();
            if(this.utmCampaign || this.utmMedium || this.utmSource){
              this.registerUTM();
            }
            if(this.IsmartId){
              this.registerIsmartId();
            }
            if(this.redirectionEmail && redirect){
              this.redirGoogle();
            }
            else{
              sessionStorage.setItem("email",window.btoa(this.email));
              sessionStorage.setItem("mob",window.btoa(this.mob));
              sessionStorage.setItem("code",ccode);
              this.registerStatus.emit(true);
              let row = {
                          "Email": this.registerForm.controls.CustomerEmail.value,
                          "Mobile": this.registerForm.controls.Mobile.value
                        }
              this.router.navigate(['/pan'], { state: row,replaceUrl: true });
            }
          }
        }, error: e =>{
          this.loader.stop();
          this.errorComp.ModalShow(e.error.Message)
        }
      });
  }

  
  registerUTM(refNo?:any){
      let ccode = '';
      if(!this.resumeUTM && this.countryCode.TeleCode){
        ccode =  this.countryCode.TeleCode;
      }else if(!this.resumeUTM){
        ccode = this.countryCode;
      }else{
        ccode = this.encData.Code
      }
    this.loader.start();
    let path = `DIY/RegisterUtm`
    var params:Params = {
      "email": this.resumeUTM ? this.encData.Email : this.email,
      "Mobile": this.resumeUTM ? this.encData.Mobile : this.mob,
      "UtmSource": this.utmSource ? this.utmSource : "",
      "Campaign": this.utmCampaign ? this.utmCampaign : "",
      "Medium": this.utmMedium ? this.utmMedium : "",
      "CountryCode": ccode,
      "ReferenceKey": "",
      "IsResume" : this.resumeUTM
    }
    if(this.resumeUTM){
      params.ReferenceNumber = refNo;
    }
    const checksum = "";

    this._http.httpPost(path, params, checksum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let val = this.encrypt.decryptUsingAES256(data.OutPut);
        if(val && val.IsSuccess){
          if(val.RK){
            sessionStorage.setItem("rkToken",val.RK);
          }
        }
        console.log(val,"utm")
      },error : err => {
        this.errorComp.ModalShow(err.error.Message);
      }

    })
  }
  registerIsmartId(){
    let path = `DIY/DIYUpdtIsmartInfo`
    var params:any = {
      "LGCode": this.rmEmail,
      "EmailId ": this.email,
      "Mobile": this.mob,
      "CountryCode": this.countryCode,
      "IsmartId": this.IsmartId,
      "ApplicationType": this.ApplicationType,
      "IsmartURL":sessionStorage.getItem('IsmartURL')
    }
    const checksum = "";

    this._http.httpPost(path, params, checksum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let val = this.encrypt.decryptUsingAES256(data.OutPut);
        if(val && val.IsSuccess){
          if(val.IsmartId){
            sessionStorage.setItem("IsmartId",val.IsmartId);
            this.IsmartId=val.IsmartId
          }
        }
        console.log(val,"IsmartId")
      },error : err => {
        this.errorComp.ModalShow(err.error.Message);
      }

    })
  }

  // numericOnly(event:any){
  //   const pattern = new RegExp('^[0-9\b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //       event.preventDefault();
  //       return;
  //   }
  // }
  numericOnly(event: any) {
    const pattern = /^[0-9\b]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      // Remove non-numeric characters from the input value
      event.target.value = inputText.replace(new RegExp(`[^0-9]+`, 'g'), '');
    }
  }
  
  telcode(event: any){
    // if(event.length > 3){
    //   event = event.substring(0, event.length-1);
    // }
    this.countryCode = event;
  }

  selectCodeEvent(event: any){
    this.inline = false;
    if(event){
      this.newCoun = event.TeleCode;
      this.countryCode = event.TeleCode;
    }
  }

  restrictEnter(args: any) {
    if (args.key === "Enter" && args.keyCode == 13)
      args.preventDefault();
  }

  getDIYStatus(ref: any){
    const ele = document.getElementsByClassName('modal-backdrop');
    const $body = document.getElementsByTagName('body');
    if($body.length >= 1){
      for(let i=0;i<$body.length;i++){
        if($body[i].classList.contains("modal-open")){
          $body[i].classList.remove("modal-open")
        }
        $body[i].style.overflowY = "scroll";
      }
    }
    if(ele.length >= 1){
      for(let i=0;i<ele.length;i++){
        if(ele[i].classList.contains("show")){
          ele[i].classList.remove("show")
          ele[i].parentNode?.removeChild(ele[i]);
          if(this.resumeModal){
            this.resumeModal.hide();
          }
        }
      }
    }
    let url = 'DIY/DIYOverallStatus';
    const checkSum = ref;
    let params = {
      'ReferenceNumber': ref
    }
    this.loader.start();
    this._http.httpPost(url,params, checkSum).subscribe({
      next: (data:any)=>{
        this.loader.stop();
        let value = this.encrypt.decryptUsingAES256(data.OutPut)
        if(value && value.IsSuccess){
          let item = value.overallLists;
          sessionStorage.setItem('NRO',value.NRO);
          this._http.setStatus({
            PIOOCIType: value.PIOOCIType, 
            Stamp: value.StampRequired, 
            RMModule: value.IsRMJourney, 
            Mariner: value.Mariner, 
            ReStatus: value.ReStatus, 
            PIOOCI: value.PIOOCI, 
            Pan: value.PanNumber
          })
          this._http.setOci(item[3].StageSkip);
          if(value.ReferenceNumber) {
            this.decref = value.ReferenceNumber;
            this._http.setRef(value.ReferenceNumber);
          }
          if(value.digilocker){
          sessionStorage.setItem("digilocker", value.digilocker)
          }
          if(item[0].DIY === 'Y' && ((item.some((item:any) => item.DIY !== 'Y')) || (item.some((item:any) => item.DBO === 'R')))){
            this.registerStatus.emit(true);
          }else{
            this.remarks = "";
            this.registerStatus.emit(false);
            sessionStorage.clear();
            this.finalmodal = true;
            this.theModal();
          }
          setTimeout(() => {
              if (item.some((item:any) => item.DBO === 'D')) {
                this.resumeDrop();
              } 
              else if (item[1].DIY !== 'Y' || item[1].DBO === 'R') {
                if(item[1].DBO !== 'R'){
                  this.router.navigate(['/pan'], { replaceUrl: true });
                }
                if(item[1].DBO === 'R'){
                  // this.remarks = item[1].Remarks;
                  this.errorComp.ModalShow(item[1].Remarks, true , '/pan');
                }
              } else if((item[12].DIY !== 'Y' || item[12].DBO === 'R') &&(value.NRO === 'Y')){
                this.router.navigate(['/photo'], { replaceUrl: true });
                if(item[12].DBO === 'R'){
                  this.remarks = item[12].Remarks;
                  this.errorComp.ModalShow(item[12].Remarks)
                }
              }
              else if(item[2].DIY !== 'Y' || item[2].DBO === 'R'){
                if(item[2].DBO !== 'R'){
                  this.router.navigate(['/passport'], { replaceUrl: true });
                }
                if(item[2].DBO === 'R'){
                  this.errorComp.ModalShow(item[2].Remarks, true , '/passport');
                }
              }
              else if((item[3].DIY !== 'Y' || item[3].DBO === 'R')&&item[3].StageSkip =='F'){
                // this.router.navigate(['/oci-pio'], { replaceUrl: true });
                if(item[3].DBO !== 'R'){
                  this.router.navigate(['/oci-pio'], { replaceUrl: true });
                }
                  if(item[3].DBO === 'R'){
                  this.errorComp.ModalShow(item[3].Remarks, true , '/oci-pio')
                  }
              }
              else if(item[4].DIY !== 'Y' || item[4].DBO === 'R'){
                if(item[4].DBO !== 'R'){
                  this.router.navigate(['/foreign-address'], { replaceUrl: true });
                }
                if(item[4].DBO === 'R'){
                  this.errorComp.ModalShow(item[4].Remarks, true , '/foreign-address');
                }
              }
              else if(item[5].DIY !== 'Y' || item[5].DBO === 'R'){
                if(item[5].DBO !== 'R'){
                  this.router.navigate(['/address'], { replaceUrl: true });
                }
                if(item[5].DBO === 'R'){
                  this.remarks = item[5].Remarks;
                  this.errorComp.ModalShow(item[5].Remarks, true , '/address');
                  // this.errorComp.ModalShow(item[5].Remarks)
                }
              }
              else if((item[6].DIY !== 'Y' || item[6].DBO === 'R')&& item[3].StageSkip !=='F'){
                if(item[6].DBO === 'R'){
                  this.errorComp.ModalShow(item[6].Remarks, true , '/visa');
                }
                if(item[6].DBO !== 'R' ){
                  this.router.navigate(['/visa'], { replaceUrl: true });
                }
              } 
              else if(item[7].DIY !== 'Y' || item[7].DBO === 'R'){
                if(item[7].DBO === 'R'){
                  this.errorComp.ModalShow(item[7].Remarks, true , '/fatca');
                }
                if(item[7].DBO !== 'R'){
                  this.router.navigate(['/fatca'], { replaceUrl: true });
                }
              }
              else if(item[11].DIY !== 'Y' || item[11].DBO === 'R'){
                if(item[11].DBO === 'R'){
                  this.errorComp.ModalShow(item[11].Remarks, true , '/fatca');
                }
                if(item[11].DBO !== 'R'){
                  this.router.navigate(['/fatca'], { replaceUrl: true });
                }
              }
              else if(item[9].DIY !== 'Y' || item[9].DBO === 'R'){
                if(item[9].DBO === 'R'){
                  this.errorComp.ModalShow(item[9].Remarks, true , '/bank');
                }
                if(item[9].DBO !== 'R'){
                  this.router.navigate(['/bank'], { replaceUrl: true });
                };
              }
              else if(item[10].DIY !== 'Y' || item[10].DBO === 'R'){
                if(item[10].DBO === 'R'){
                  this.errorComp.ModalShow(item[10].Remarks, true , '/segments');
                }
                if(item[10].DBO !== 'R'){
                  this.router.navigate(['/segments'], { replaceUrl: true });
                }
              }
              
              // else if(item[8].DIY !== 'Y' || item[8].DBO === 'R'){
              //   this.router.navigate(['/ridetails'], { replaceUrl: true });
              //   if(item[8].DBO === 'R'){
              //     this.remarks = item[8].Remarks;
                  
              //     this.errorComp.ModalShow(item[8].Remarks)
              //   }
              // }
              
              
              // else if(item[12].DIY !== 'Y' || item[12].DBO === 'R'){
              //   this.router.navigate(['/photo'], { replaceUrl: true });
              //   if(item[12].DBO === 'R'){
              //     this.remarks = item[12].Remarks;
              //     this.errorComp.ModalShow(item[12].Remarks)
              //   }
              // }
               else if((item[13].DIY !== 'Y' || item[13].DBO === 'R')&&(value.NRO === 'Y')){
                this.router.navigate(['/signature'], { replaceUrl: true });
                if(item[13].DBO === 'R'){
                  this.remarks = item[13].Remarks;
                  this.errorComp.ModalShow(item[13].Remarks)
                }
              }
              else if(((item[13].DIY === 'Y' || item[14].DIY !== 'Y')&& (item[15].DIY !== 'Y' &&this.EsignStatus?.toLowerCase() !== 'failed'))&&(value.NRO === 'Y')){
                this.router.navigate(['/terms'], { replaceUrl: true });
              }
              else if(item[14].DIY !== 'Y' || item[14].DBO === 'R'){
                if(item[14].DBO === 'R'){
                  this.errorComp.ModalShow(item[14].Remarks, true , '/aof');
                }
                if(item[14].DBO !== 'R'){
                  this.router.navigate(['/aof'], { replaceUrl: true });
                }
              }
              else if((item[15].DIY !== 'Y' || item[15].DBO === 'R')&&(value.NRO === 'Y')){
                if(item[15].DBO === 'R'){
                  this.errorComp.ModalShow(item[15].Remarks, true , '/aof');
                  // this.router.navigate(['/aof'], { replaceUrl: true });
                }else if(item[15].DIY !== 'Y'){
                  this.router.navigate(['/aof'], { replaceUrl: true });
                }
                else if(item[15].DBO !== 'R' &&item[15].DIY === 'Y'){
                  this.router.navigate(['/complete'], { replaceUrl: true });
                }
              }
              else{
                this.remarks = "";
                // this.regScreen = true;
                this.registerStatus.emit(false);
                sessionStorage.clear();
                this.finalmodal = true;
                this.theModal();
                // this.router.navigate(['/complete'], { replaceUrl: true });
              }
            
          }, 0);
          
         
        }
      },
      error: (_error: any)=>{
        this.loader.stop();
      }
    });
  }
  screenEvent(event:boolean){
    this.regScreen = event;
  }

  // genRefNumber(){
  //   let a:any = this.registerForm.controls.CustomerPan.value?.toUpperCase();
  //   let b:any = this.registerForm.value.Mobile;
  //   let c:any = this.email;
  //   let d:any = this.registerForm.value.CustomerName;
  //   const checkSum = a+b+c+d;
  //   let ccode = '';
  //   if(this.countryCode.TeleCode){
  //     ccode =  this.countryCode.TeleCode;
  //   }else{
  //     ccode = this.countryCode;
  //   }
  //   const params = {
  //     "Mode":"N",
  //     "PanNumber": a,
  //     "Mobile": b,
  //     "Email": c,
  //     "CustomerName": d,
  //     "FirstName": this.firstName,
  //     "MiddleName": this.middleName,
  //     "LastName": this.lastName,
  //     "CountryCode": ccode,
  //     "IsRM": this.rmAssist,
  //     "RMEmail": this.rmEmail ? this.rmEmail + this.rmDomain : ''
  // }
  // this.loader.start();
  // const path = 'DIY/ReferenceNumberGeneration';
  // this._http.httpPost(path, params, checkSum).subscribe({
  //   next: (data: any)=>{
  //     let value1= this.encrypt.decryptUsingAES256(data.OutPut)
  //     this.loader.stop();
  //     if(value1.IsSuccess){
  //       sessionStorage.setItem('AxNo',value1.EncRefNumber);
  //       this._http.setRefNum(value1.EncRefNumber);
  //       if(value1.IsReferenceNumberExist){
  //         this.getDIYStatus(value1.EncRefNumber)
  //       }else{
  //         this.registerStatus.emit(true);
  //         this.getDIYStatus(value1.EncRefNumber)
  //         let row = {
  //           "EncRefNumber": value1.EncRefNumber,
  //           "RefNumber": value1.ReferenceNumber,
  //           "PAN": this.registerForm.controls.CustomerPan.value?.toUpperCase(),
  //           "Email": this.registerForm.controls.CustomerEmail.value,
  //           "Mobile": this.registerForm.controls.Mobile.value
  //         }
  //         this.router.navigate(['/pan'], {state: row, replaceUrl: true });
  //       }
  //     }
  //   }, error: e =>{
  //     this.loader.stop();
  //     this.errorComp.ModalShow(e.error.Message)
  //   }
  // });

  // }

  // emailOnly(event:any){
  //   const pattern = new RegExp('^[-a-zA-Z0-9._@\b]+$');
  //       const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //       if (!pattern.test(key) && event.charCode !== 0) {
  //           event.preventDefault();
  //           return;
  //     }
  // }

  emailOnly(event: any) {
    const pattern = /^[-a-zA-Z0-9._@]+$/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      // Remove non-email characters from the input value
      event.target.value = inputText.replace(new RegExp(`[^-a-zA-Z0-9._@]+`, 'g'), '');
    }
  }

  rmEmailBlur(){
    if(!this.rmEmail){
      this.rmEmailEmpty = true;
    }else{
      this.rmEmailEmpty = false;
    }
  }

  // noSpace(event: any){
  //   const pattern = new RegExp('^[-a-zA-Z0-9._\b]+$');
  //   const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  //   if (!pattern.test(key) && event.charCode !== 0) {
  //     event.preventDefault();
  //     return;
  //   }
  // }

  noSpace(event: any) {
    const pattern = /^[-a-zA-Z0-9._\b]+/;
    const inputText = event.target.value;
  
    if (!pattern.test(inputText)) {
      // Remove spaces and non-allowed characters from the input value
      event.target.value = inputText.replace(new RegExp(`[^-a-zA-Z0-9._]+`, 'g'), '');
    }
  }
  

  reSendOTPStatus(event: any){
    this.reSendOTP = event;
  }

  reSendResumeOTPStatus(event: any){
    this.reSendResumeOTP = event;
  }

  dropToggle(){
    this.emailToggle = !this.emailToggle
  }

  theModal() {
    this.registerStatus.emit(false);
    console.log("modal");
    const element = document.getElementById('staticBackdrop') as HTMLElement;
    this.staticBackdrop = new Modal(element, { backdrop: 'static', keyboard: false });
    this.staticBackdrop.show();
  }
  errorModal() {
    const element = document.getElementById('dbError') as HTMLElement;
    this.errorModalbox = new Modal(element, { backdrop: 'static', keyboard: false });
    this.errorModalbox.show();
    return
  }

  //renew dropped status
  resumeDrop() {
    const params = {
      "ReferenceNumber": sessionStorage.getItem('AxNo'),
    }
    let checkSum = sessionStorage.getItem('AxNo');
    this.loader.start();
    const path = 'DIY/ResumeDrop';
    this._http.httpPost(path, params, checkSum).subscribe({
      next: (data: any) => {
        let value2 = this.encrypt.decryptUsingAES256(data.OutPut)
        this.loader.stop();
        if (value2 && value2.IsSuccess) {

        } else {
          if (value2 && value2.Error) {
            this.errorComp.ModalShow(value2.Error)
          } else {
            this.errorComp.ModalShow("Please try again later.")
          }
        }
      }, error: (_error: any) => {
        this.loader.stop();
        this.errorComp.ModalShow(_error.error.Message)
      }
    });
  }

  generateOTP(){
    if(!this.emailmodal){
    const element = document.getElementById('otpModal') as HTMLElement;
    this.errorModalbox = new Modal(element, { backdrop: 'static', keyboard: false });
    this.errorModalbox.show();
    this.timer = true;
    this.emailmodal = true;
    }
  }
  mobgenerateOTP(){
    if(!this.mobilemodal){
    const element = document.getElementById('otpModal') as HTMLElement;
    this.errorModalbox = new Modal(element, { backdrop: 'static', keyboard: false });
    this.errorModalbox.show();
    this.timer = true;
    if(this.NRO === 'Y'){
    this.mobilemodal = true;
    }
    }
  }

  onOtpChange(otp: any) {
    this.otp = otp;
    this.emailOTP = otp;
  }

  otpClear(){
    this.mobilemodal = false;
     this.emailmodal = false;
    this.timer = false;
    if(this.otp){
      this.ngOtpInput.setValue("");
    }
    this.registerForm.enable();
    this.codeDisable = false;
    if(this.rmchekbox){
      this.rmchekbox = false;
    }
  }

  resumeotp(event:any){
    this.resumeOTP = event;
  }
  manuallyemail(){
    this.EmailField = true;
  }
  NroSubmit(){
    sessionStorage.setItem('NRO',this.NRO);
    if(this.NRO !== 'Y'){
      this.EmailField = true;
      this.genOTP()

            // const element = document.getElementById('googleModal') as HTMLElement;
            // this.googleModal = new Modal(element, { backdrop: 'static', keyboard: false });
            // this.googleModal.show();
    }else{
      this.MobgenOTP()
    }
  }
nropopup(){
    const element = document.getElementById('NROPop') as HTMLElement;
            this.NROPop = new Modal(element, { backdrop: 'static', keyboard: false });
            this.NROPop.show();
}
  TandC(content:string){
    if(content === "terms"){
      this.fatf = false;
    } else{
      this.fatf = true;
    }
    const element = document.getElementById('tandcPopup') as HTMLElement;
    if(element){
      this.tcPopUp = new Modal(element, { backdrop: 'static', keyboard: false });
      this.tcPopUp.show();
    }
  }
}

export interface RMParams {
  CustomerEmail:string | null;
  RMEmail:string;
  IsRMJourney:boolean;
  Email:string;
  Mobile:any;
  RMID?:string | number;
  NRO:string;
}